import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { CardBulleted, KeyOutline, SlotMachine, StarFourPoints } from '@patrianna-icons/material-icons'
import cx from 'classnames'
import { useLayoutEffect, useState } from 'react'

import { IS_BRAND_PULSZ } from 'config/brands'
import common from 'prismic-translates/common.json'

import classes from './styles.module.scss'

const t = getTranslationFromJson([common])

const AdsSvg = <img src={`${process.env.IMG_ORIGIN}/icons/noAds.svg`} alt='no ads' style={{ minWidth: 30 }} />
const KeySvg = <KeyOutline style={{ transform: 'rotate(90deg)' }} />
const CardSvg = <CardBulleted />
const SlotSvg = <SlotMachine />
const StarSvg = <StarFourPoints />
const PulszPointsSvg = (
  <img src={`${process.env.IMG_ORIGIN}/icons/pulsz-points.svg`} alt='Pulsz points' style={{ minWidth: 32 }} />
)

const points = IS_BRAND_PULSZ
  ? {
      svg: PulszPointsSvg,
      text1: 'Get more',
      text2: t('pulsz_points'),
    }
  : {
      svg: StarSvg,
      text1: 'Get more',
      text2: 'VIP Points',
    }

const content = [
  {
    svg: KeySvg,
    text1: 'Get Golden Key to unlock',
    text2: 'exclusive games for 7 days',
  },
  {
    svg: SlotSvg,
    text1: 'Exclusive',
    text2: 'Slots games',
  },
  {
    svg: AdsSvg,
    text1: 'All ads removed',
    text2: 'with any purchase',
  },
  {
    svg: CardSvg,
    text1: 'Exclusive',
    text2: 'Scratchcard games',
  },
  points,
]

const contentDuplicated = [...new Array(content.length * 2)].map((_, i) =>
  i >= content.length ? content[i - content.length] : content[i],
)

export default function BenefitsSection() {
  const [startAnimation, setStartAnimation] = useState(false)

  useLayoutEffect(() => {
    setStartAnimation(true)
  }, [])

  return (
    <div className={classes.wrap}>
      <div className={cx({ [classes.slideTrack]: startAnimation })}>
        {contentDuplicated.map((item, index) => (
          <div key={index} className={classes.item}>
            <div className={classes.svg}>{item.svg}</div>
            <div className={classes.text}>
              <p>{item.text1}</p>
              <p>{item.text2}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
